export default {
  /**
   *
   * @param state
   * @param counts
   */
  setEmployeeDashboardDailyAttendanceCount(state, counts) {
    state.counts = counts;
  },
};
